/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * SkippedShopifyOrderDtoBase
 * auto generated base class for the model SkippedShopifyOrderDtoModel.
 */
export const SkippedShopifyOrderDtoModelBase = ModelBase
  .named('SkippedShopifyOrderDto')
  .props({
    __typename: types.optional(types.literal("SkippedShopifyOrderDto"), "SkippedShopifyOrderDto"),
    shopifyOrderId: types.union(types.undefined, types.string),
    orderName: types.union(types.undefined, types.null, types.string),
    reason: types.union(types.undefined, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class SkippedShopifyOrderDtoModelSelector extends QueryBuilder {
  get shopifyOrderId() { return this.__attr(`shopifyOrderId`) }
  get orderName() { return this.__attr(`orderName`) }
  get reason() { return this.__attr(`reason`) }
}
export function selectFromSkippedShopifyOrderDto() {
  return new SkippedShopifyOrderDtoModelSelector()
}

export const skippedShopifyOrderDtoModelPrimitives = selectFromSkippedShopifyOrderDto().shopifyOrderId.orderName.reason
